/* ==========================================================================
  Load more post with  AJAX in archives realisation and post pages
========================================================================== */

jQuery(document).ready(function($){

  $('.load-more--archive').click(function(e) {

    e.preventDefault();

		var button  = $(this),
        html    = $(this).html(),
		    datas   = {
    			'action':  'load_more_posts',
    			'query':   opt.posts,
    			'page' :   opt.current_page,
          'nonce':   opt.nonce
    		};

		$.ajax({
			url  : opt.ajaxUrl,
			data : datas,
			type : 'POST',
			beforeSend : function ( xhr ) {
				button.text('Chargement...'); // change the button text, you can also add a preloader image
			},
			success : function( data ){
				if( data ) {

					button.html( html ).parent().before(data); // insert new posts

					opt.current_page++;

          // if last page, remove the button
					if ( parseInt(opt.current_page) === parseInt(opt.max_page) ) {
            button.remove();
          }

				} else {
					button.remove(); // if no data, remove the button as well
				}
			}
		});
	});

});
